import { handleActions } from "redux-actions";
import produce from "immer";
import { API_START, API_END } from "../constants/actionTypes";
import { callApiLabel, login, uploading } from "../constants/labels";

export default handleActions(
  {
    [API_START]: produce((state, action) => {
      if (action.payload === login) state[login] = true;
      if (action.payload === uploading) state[uploading] = true;
      if (action.payload === callApiLabel) state[callApiLabel] = true;
    }),
    [API_END]: produce((state, action) => {
      if (action.payload === login) state[login] = false;
      if (action.payload === uploading) state[uploading] = false;
      if (action.payload === callApiLabel) state[callApiLabel] = false;
    }),
  },
  {}
);